import { render, staticRenderFns } from "./user-info-change-password.vue?vue&type=template&id=726733c6&scoped=true&"
import script from "./user-info-change-password.vue?vue&type=script&lang=ts&"
export * from "./user-info-change-password.vue?vue&type=script&lang=ts&"
import style0 from "./user-info-change-password.vue?vue&type=style&index=0&id=726733c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726733c6",
  null
  
)

export default component.exports